export const tableColumns = [
  {
    label: '户名',
    prop: 'consName',
  },
  {
    label: '户号',
    prop: 'consNo',
  },

  {
    label: '基线平均值',
    prop: 'loadValue',
  },
  {
    label: '调节量',
    prop: 'downLoad',
  },
];
